import React from 'react';
import { ShadowRootWrapper } from '../ShadowRootWrapper';
import type { ThemeMode } from '../theme';

export interface ThemeScopeProps {
    mode?: ThemeMode;
    fontFamily?: string;
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

/**
 * Pins a subtree to a fixed Malachite theme via its own shadow root — a themed island (e.g. a dark
 * panel in a light app). The dedicated root is required: theme tokens are scoped per shadow root.
 */
const ThemeScope: React.FC<ThemeScopeProps> = ({
    mode = 'dark',
    fontFamily,
    className = '',
    style,
    children,
}) => {
    const fontStyle = fontFamily
        ? ({ fontFamily, '--font-sans': fontFamily } as React.CSSProperties)
        : undefined;
    return (
        <ShadowRootWrapper theme={mode} hostStyle={{ width: '100%' }}>
            <div className={className} style={{ marginInline: 'auto', ...fontStyle, ...style }}>
                {children}
            </div>
        </ShadowRootWrapper>
    );
};

export default ThemeScope;
export { ThemeScope };
